import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-item" }
const _hoisted_2 = { class: "nav-item d-flex align-items-center" }
const _hoisted_3 = { class: "d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brand_logo = _resolveComponent("brand-logo")!
  const _component_data_bs_theme = _resolveComponent("data-bs-theme")!
  const _component_nav_links = _resolveComponent("nav-links")!
  const _component_off_canvas_navbar = _resolveComponent("off-canvas-navbar")!
  const _component_app_header = _resolveComponent("app-header")!

  return (_openBlock(), _createBlock(_component_app_header, { theme: _ctx.theme }, {
    brand: _withCtx(() => [
      _createVNode(_component_brand_logo, {
        to: "/home",
        "img-style": "max-height: 36px; max-width: 250px"
      })
    ]),
    actions: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "offcanvas",
        "data-bs-target": "#offcanvasNavbar",
        "aria-controls": "offcanvasNavbar"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)
    ]))]),
    drawer: _withCtx(() => [
      _createVNode(_component_off_canvas_navbar, {
        onChangeTheme: _cache[2] || (_cache[2] = ($event: any) => (_ctx.theme = $event))
      }, {
        "nav-panel": _withCtx(() => [
          _createVNode(_component_nav_links, { links: _ctx.navMenu }, {
            default: _withCtx(() => [
              _createElementVNode("li", _hoisted_1, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link rounded position-relative", _ctx.$route.name == 'Settings' ? 'active disabled' : '']),
                  "aria-current": "page",
                  "data-bs-dismiss": "offcanvas",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'Settings' }))),
                  style: {"cursor":"pointer"}
                }, _toDisplayString(_ctx.$t("nav.settings")), 3)
              ]),
              _createElementVNode("li", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_data_bs_theme, {
                    onChangeTheme: _cache[1] || (_cache[1] = ($event: any) => (_ctx.theme = $event))
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["links"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme"]))
}